module.exports = __webpack_public_path__ + "img/HA2504-P12A.fd249464.jpg";